import type { FC } from 'react';
import React from 'react';

export const PauseIcon: FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="11.5" fill="white" stroke="black" />
      <rect x="9" y="7" width="1" height="10" rx="0.5" fill="black" />
      <rect x="14" y="7" width="1" height="10" rx="0.5" fill="black" />
    </svg>
  );
};
